import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { TeamMembersRequestStatus } from '__generated__/GQL';
import Loader from 'components/Loader';

import useTeamMembersInvitationQuota from './hooks/useTeamMembersInvitationQuota';
import Members from './pages/Members';
import { MemberRoleTransition } from './pages/Members/components/RoleTransition';
import MemberInvite from './pages/MembersInvite';
import Requests from './pages/Requests';
import { useRequests } from './pages/Requests/hooks/useRequests';
import * as routes from './routes';

const Team: FC = () => {
  const {
    pageInfo: { totalCount },
  } = useRequests([TeamMembersRequestStatus.Pending]);
  const hasPendingTeamMembersRequests = totalCount > 0;

  const {
    loading,
    teamMemberInvitationsQuota: { limit: invitationsLimit },
  } = useTeamMembersInvitationQuota();

  if (loading) {
    return <Loader />;
  }

  return (
    <Switch>
      <Route component={Members} exact path={routes.members} />
      <Route component={MemberInvite} path={routes.membersInvite} />
      <Route
        component={MemberRoleTransition}
        path={routes.memberRoleTransition}
      />

      {invitationsLimit > 1 ? (
        <Route component={Requests} path={routes.request} />
      ) : null}

      <Route path="*">
        <Redirect
          to={
            hasPendingTeamMembersRequests && invitationsLimit > 1
              ? routes.defaultRequests
              : routes.members
          }
        />
      </Route>
    </Switch>
  );
};

export default Team;
